<template>
  <v-dialog v-model="dialog.display" max-width="300">
    <v-card>
      <v-card-text class="px-7 py-7">
        {{ dialog.title }}
      </v-card-text>
      <v-card-actions class="mt-0 px-5">
        <v-spacer></v-spacer>
        <v-btn text @click="cancel()">{{ $t("btn.no") }}</v-btn>
        <v-btn
          text
          color="primary"
          class="font-weight-bold"
          @click="confirm()"
          >{{ $t("btn.yes") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      default: function() {
        return {
          display: false,
          title: null,
        };
      },
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
      this.dialog.display = false;
    },
    confirm() {
      this.$emit("confirm");
      this.dialog.display = false;
    },
  },
};
</script>
